import React, { Component, createRef } from 'react';
import PropTypes from 'prop-types';

import Document from 'common/components/Document/Document';

import styles from './AccordionPanel.module.scss';

export default class AccordionPanel extends Component {
  static propTypes = {
    description: PropTypes.string.isRequired,
    file: PropTypes.array.isRequired,
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired
  };

  panelRef = createRef();

  render() {
    const activePanelClass = this.props.isOpen ? styles.PanelActive : '';
    const activePanelButtonClass = this.props.isOpen
      ? styles.PanelButtonActive
      : '';

    const { description, file, isOpen, onClose, title } = this.props;

    return (
      <li>
        <button
          className={`${styles.PanelButton} ${activePanelButtonClass}`}
          onClick={onClose}
        >
          {title}
        </button>
        <div
          ref={this.panelRef}
          style={
            isOpen
              ? {
                  height: this.panelRef.current
                    ? this.panelRef.current.scrollHeight
                    : '0px'
                }
              : { height: '0px' }
          }
          className={`${styles.Panel} ${activePanelClass}`}
        >
          <div
            dangerouslySetInnerHTML={{
              __html: description
            }}
          />
          {Boolean(file.length) &&
            file.map(document => (
              <Document key={document.system.id} document={document} />
            ))}
        </div>
      </li>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/components/AccordionList/components/AccordionPanel/AccordionPanel.js